var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.386719,
    width: 350,
    height: 233,
    fill: "#DD9269"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.969 75.1719C194.969 72.9627 196.76 71.1719 198.969 71.1719H305.252C307.461 71.1719 309.252 72.9627 309.252 75.1719V153.523H194.969V75.1719Z",
    fill: "#112D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.012 80.2148C200.012 78.0057 201.803 76.2148 204.012 76.2148H300.211C302.42 76.2148 304.211 78.0057 304.211 80.2148V151.843H200.012V80.2148Z",
    fill: "#357280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.414 145.629V139.688H282.531C283.914 139.688 284.591 140.516 284.591 141.616C284.591 142.711 283.91 143.544 282.531 143.544H281.317V145.629H280.414ZM281.317 142.773H282.441C283.315 142.777 283.68 142.285 283.68 141.616C283.68 140.943 283.315 140.463 282.441 140.459H281.317V142.773Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.765 145.686C285.444 145.682 285.178 145.424 285.182 145.104C285.178 144.784 285.444 144.521 285.765 144.521C286.08 144.521 286.343 144.784 286.347 145.104C286.343 145.424 286.08 145.682 285.765 145.686Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.48 145.629V139.688H289.597C290.98 139.688 291.657 140.516 291.657 141.616C291.657 142.711 290.975 143.544 289.597 143.544H288.382V145.629H287.48ZM288.382 142.773H289.507C290.381 142.777 290.746 142.285 290.746 141.616C290.746 140.943 290.381 140.463 289.507 140.459H288.382V142.773Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.413 139.688V145.629H292.535V139.688H293.413Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.4 145.719C295.087 145.719 294.278 144.812 294.283 143.43C294.278 142.059 295.099 141.115 296.342 141.115C297.356 141.115 298.32 141.743 298.32 143.356V143.668H295.152C295.177 144.517 295.678 144.997 296.408 144.997C296.904 144.997 297.229 144.784 297.376 144.513H298.263C298.066 145.235 297.38 145.719 296.4 145.719ZM295.157 143.011H297.458C297.458 142.334 297.019 141.833 296.351 141.838C295.649 141.833 295.193 142.383 295.157 143.011Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.289,
    y: 151.844,
    width: 117.645,
    height: 10.0838,
    rx: 4,
    fill: "#112D33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.289 155.205C193.289 153.349 194.794 151.844 196.65 151.844H307.572C309.429 151.844 310.934 153.349 310.934 155.205V155.205H193.289V155.205Z",
    fill: "#3E98A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.211 151.843V80.2148C304.211 78.0057 302.42 76.2148 300.211 76.2148H205.389L295.961 151.843H304.211Z",
    fill: "#1D4953",
    fillOpacity: 0.59
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool02);
export default __webpack_public_path__ + "static/media/school_02.89cd954dc68cc3093fe6ac0f74365037.svg";
export { ForwardRef as ReactComponent };